// 导入axios接口
import axiosRequest from '@/utils/axios-default-request';


//配置axios接口
/** 
 * // 获取当前可进行结算的项目信息 
 * @param supUserId用户id,  String jgStartTime, String jgEndTime接稿起止时间
 * @back SupProjectList项目列表，sqStartTime，sqEndTime搜索申请的起止时间，zjhj人民币总金额，
 *  mjzjhj美元总金额，supCurrency币种，sqjs是否允许提现 true可提现 false不可提现
 */ 
let getFYJSProjectList = (data) => axiosRequest.postBody('/supinterface/getFYJSProjectList',data)

/** 
 * // 提交结算申请 
 * @param Long supUserId用户id, String projectIds项目id, String sqStartTime, 
 *  String sqEndTime,搜索申请的起止时间,zje总金额, 
 * jsfs结算方式（1 中国境内银行卡 2 Paypal 3 Payponner 对应着传数字）
 */ 
let getJSSQ = (data) => axiosRequest.postBody('/supinterface/getJSSQ',data)

/** 
 * // 查看费用明细 
 * @param Long supUserId用户ID, String jgStartTime, String jgEndTime接稿起止时间,
 *  String jsStartTime,String jsEndTime结算起止时间, String jszt结算状态, String jslx结算方式
 * @back SupProjectList项目列表，zjhj人民币总金额，mjzjhj美元总金额，supCurrency币种
 */ 
 let getFYMXProjectList = (data) => axiosRequest.postBody('/supinterface/getFYMXProjectList',data)

 
/** 
 * 获取提现申请记录
 */ 
 let getWithdrawalRecords = (data) => axiosRequest.postBody('/supinterface/getWithdrawalRecords',data)

 /** 
 * 解封申请
 */ 
 let getUnblockingSQ = (data) => axiosRequest.postBodyJson('/supinterface/getUnblockingSQ',data)

 /**
  * @param 接口名称： getGRRZData 参数： supUserId
  * @back 验证通过true,验证不通过false
  */
  let getGRRZData = (data) => axiosRequest.postBody('/supinterface/getGRRZData',data)

  /**
   * @param getJSFSRZData  查询结算方式认证情况   传参数supUserId
   */
  let getJSFSRZData = (data)=> axiosRequest.postBody('/supinterface/getJSFSRZData',data)

  // 查询个人认证情况
  let getSMRZ = (data)=> axiosRequest.postBody('/supinterface/getSMRZ',data)
  
  // 查询个人认证情况
  let getSmrzXX = (data)=> axiosRequest.postBody('/supinterface/getSmrzXX',data)
  

export default{
    getFYJSProjectList,//获取当前可进行结算的项目信息
    getJSSQ,//提交结算申请
    getFYMXProjectList,//查看费用明细
    getWithdrawalRecords,//获取提现申请记录
    getGRRZData,//
    getJSFSRZData,// 查询结算方式认证情况
    getSMRZ,// 查询个人认证情况
    getSmrzXX,// 查询个人实名认证情况
    getUnblockingSQ,//解封申请
}